export default __webpack_public_path__ + "static/media/centris_data_transfer_not_start_button_fr.451f773a.png";